import { supabase } from './supabaseClient';
import Cookies from 'js-cookie';

export const getDueTasks = async (userId) => {
    try {
        const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
        const next7Days = new Date();
        next7Days.setDate(next7Days.getDate() + 7);
        const next30Days = new Date();
        next30Days.setDate(next30Days.getDate() + 30);
        const { data, error } = await supabase
            .from('tasks')
            .select('*')
            .eq('user_id', userId)
            .in('status', ['pending', 'Pending'])
            .gte('due_date', today);

        if (error) {
            throw error;
        }

        const todayTasks = [];
        const next7DaysTasks = [];
        const next30DaysTasks = [];
        data.forEach(task => {
            const dueDate = new Date(task.due_date).toISOString().split('T')[0];
            if (dueDate === today) {
                todayTasks.push(task);
            } else if (dueDate > today && dueDate <= next7Days.toISOString().split('T')[0]) {
                next7DaysTasks.push(task);
            } else if (dueDate > next7Days.toISOString().split('T')[0] && dueDate <= next30Days.toISOString().split('T')[0]) {
                next30DaysTasks.push(task);
            }
        });

        return {
            today: todayTasks,
            next7Days: next7DaysTasks,
            next30Days: next30DaysTasks
        };
    } catch (error) {
        console.error('Error fetching due tasks:', error);
        return {
            today: [],
            next7Days: [],
            next30Days: []
        };
    }
}

export const AddTask = async (taskData) => {
    try {
        const { title, description, dueDate, category, subcategory, UserId } = taskData;

        // Check if the category contains any numbers
        const oldCategory = /^\d+$/.test(category);
        const oldSubCategory = /^\d+$/.test(subcategory);
        let categoryId = null;
        if (oldCategory) {
            categoryId = category;
        } else {
            const { data, error } = await supabase
                .from('categories')
                .insert([{
                    name: category,
                    parent_category_id: null,
                    user_id: UserId
                }])
                .select();

            if (error) {
                console.error('Error creating chat session:', error);
                throw error;
            }
            categoryId = data[0].id;

        }

        if (subcategory !== "null") {
            if (oldSubCategory) {
                categoryId = subcategory;
            } else {
                const { data: subdata, error } = await supabase
                    .from('categories')
                    .insert([{
                        name: subcategory,
                        parent_category_id: categoryId,
                        user_id: UserId
                    }])
                    .select();

                if (error) {
                    console.error('Error creating chat session:', error);
                    throw error;
                }
                categoryId = subdata[0].id;
            }
        }
        let dataToInsert = {
            title,
            description,
            due_date: dueDate === '' ? null : dueDate,
            user_id: UserId,
            status: 'pending'
        }
        if (categoryId != "0") {
            dataToInsert.category_id = categoryId

        }
        const { data, error } = await supabase
            .from('tasks')
            .insert([
                dataToInsert
            ]);

        if (error) {
            throw error;
        }
        return true;



    } catch (error) {
        console.error('Error adding task or category:', error);
    }
}

export const AddNote = async (NotesData) => {
    try {
        
        const { title, description, category, subcategory, UserId } = NotesData;

        // Check if the category contains any numbers
        const oldCategory = /^\d+$/.test(category);
        const oldSubCategory = /^\d+$/.test(subcategory);
        let categoryId = null;
        if (oldCategory) {
            categoryId = category;
        } else {
            const { data, error } = await supabase
                .from('notes_categories')
                .insert([{
                    name: category,
                    parent_category_id: null,
                    user_id: UserId
                }])
                .select();

            if (error) {
                console.error('Error creating notes catergory session:', error);
                throw error;
            }
            categoryId = data[0].id;

        }

        if (subcategory !== "null") {
            if (oldSubCategory) {
                categoryId = subcategory;
            } else {
                const { data: subdata, error } = await supabase
                    .from('notes_categories')
                    .insert([{
                        name: subcategory,
                        parent_category_id: categoryId,
                        user_id: UserId
                    }])
                    .select();

                if (error) {
                    console.error('Error creating chat session:', error);
                    throw error;
                }
               
                categoryId = subdata[0].id;
            }
        }
        let dataToInsert = {
            title,
            description,
            user_id: UserId,
            status: 'pending'
        }
        
        if (categoryId != "0") {
            dataToInsert.category_id = categoryId

        }
        const { data, error } = await supabase
            .from('notes')
            .insert([
                dataToInsert
            ]);

        if (error) {
            console.log("error",error);
            
            throw error;
        }
        return true;


    } catch (error) {
        console.error('Error adding notes or notes category:', error);

    }
}

export const AddList = async(listData) => {
    
    try {
        const { title, description, category, subcategory, UserId } = listData;
            const oldCategory = /^\d+$/.test(category);
            const oldSubCategory = /^\d+$/.test(subcategory);
            let categoryId = null;
            if (oldCategory) {
                categoryId = category;
            } else {
                
                
                const { data, error } = await supabase
                    .from('lists_categories')
                    .insert([{
                        name: category,
                        parent_category_id: null,
                        user_id: UserId
                    }])
                    .select();

                if (error) {
                    console.error('Error creating notes catergory session:', error);
                    throw error;
                }
                categoryId = data[0].id;

            }

            if (subcategory !== "null") {
                if (oldSubCategory) {
                    categoryId = subcategory;
                } else {
                    const { data: subdata, error } = await supabase
                        .from('lists_categories')
                        .insert([{
                            name: subcategory,
                            parent_category_id: categoryId,
                            user_id: UserId
                        }])
                        .select();

                    if (error) {
                        console.error('Error creating chat session:', error);
                        throw error;
                    }
                
                    categoryId = subdata[0].id;
                }
            }
            let dataToInsert = {
                title,
                description,
                user_id: UserId,
                status: 'pending'
            }
            
            if (categoryId != "0") {
                dataToInsert.category_id = categoryId

            }
            const { data, error } = await supabase
                .from('lists')
                .insert([
                    dataToInsert
                ]);

            if (error) {
                console.log("error",error);
                
                throw error;
            }
            return true;

    } catch (error) {
        console.error('Error adding list or list category:', error);
        
    }
}

export const AddGrocery = async (groceryData) => {
    try {
        const { title, description, category, subcategory, UserId } = groceryData;

        // Check if the category contains any numbers (existing category ID)
        const oldCategory = /^\d+$/.test(category);
        const oldSubCategory = /^\d+$/.test(subcategory);
        let categoryId = null;

        if (oldCategory) {
            categoryId = category;
        } else if (category && category !== '0') {
            // Create new category in grocery_categories
            const { data, error } = await supabase
                .from('grocery_categories')
                .insert([{
                    name: category,
                    parent_category_id: null,
                    user_id: UserId
                }])
                .select();

            if (error) {
                console.error('Error creating grocery category:', error);
                throw error;
            }
            categoryId = data[0].id;
        }

        if (subcategory && subcategory !== "null") {
            if (oldSubCategory) {
                categoryId = subcategory;
            } else {
                const { data: subdata, error } = await supabase
                    .from('grocery_categories')
                    .insert([{
                        name: subcategory,
                        parent_category_id: categoryId,
                        user_id: UserId
                    }])
                    .select();

                if (error) {
                    console.error('Error creating grocery subcategory:', error);
                    throw error;
                }
                categoryId = subdata[0].id;
            }
        }

        let dataToInsert = {
            title,
            description,
            user_id: UserId,
            status: 'pending'
        }

        // grocery_table uses grocery_table_id for category reference
        if (categoryId && categoryId !== "0") {
            dataToInsert.grocery_table_id = categoryId;
        }

        const { data, error } = await supabase
            .from('grocery_table')
            .insert([dataToInsert]);

        if (error) {
            console.log("error", error);
            throw error;
        }
        return true;

    } catch (error) {
        console.error('Error adding grocery item or category:', error);
    }
}
